export default {
  header: {
    title: 'Toutes les expéditions',
    newDispatch: 'Nouvelle expédition',
    dashboard: 'DashboardTableau de bord',
    management: 'La gestion',
    dispatches: 'Dépêches',
    clock: {
      usButton: 'Etats-Unis',
      mexicoButton: 'Mexique',
      canadaButton: 'Canada',
      yourTimeZone: 'Votre fuseau horaire',
      pacific: 'Pacifique',
      mountain: 'Montagne',
      central: 'Central',
      eastern: 'Est',
      arizona: 'Arizona',
      alaska: 'Alaska',
      hawaii: 'Hawaii',
      atlantic: 'Atlantique',
      newfoundland: 'Terre-Neuve'
    }
  },
  filters: {
    searchDispatches: 'Rechercher des dépêches',
    sortBy: 'Trier Par',
    clients: 'Clients',
    lastUpdateNewest: 'Dernière mise à jour (la plus récente en premier)',
    lastUpdateOldest: 'Dernière mise à jour (la plus ancienne en premier)',
    openOnly: 'Ouvert uniquement',
    dispatchStatus: 'Statut d\'expédition',
    dispatchState: 'État d\'expédition',
    type: 'Taper',
    noAssignedProvider: 'Aucun fournisseur attribué',
    refreshDispatchList: 'Actualiser la liste de distribution',
    approachingETA: 'Approche de l\'ETA',
    late: 'En retard',
    onTime: 'À l\'heure',
    needsApproval: 'Nécessite une approbation',
    needsCancelApproval: 'Nécessite une approbation d\'annulation',
    statuses: {
      Accepted: 'Accepté',
      'In Route': 'En Route',
      'On Scene': 'Sur Scène',
      'Tow In Progress': 'Remorquage en Cours',
      'Destination Arrival': 'Arrivée à Destination',
      Complete: 'Compléter',
      New: 'Nouveau',
      Cancelled: 'Cancelled',
      GOA: 'Parti à L\'arrivée'
    },
    states: {
      'Provider on the way': 'Prestataire en route',
      'Provider on site': 'Prestataire sur place',
      'Provider at Drop off': 'Prestataire au dépôt',
      'Provider En-route to Drop off': 'Fournisseur en route vers le dépôt',
      'Provider Completed': 'Fournisseur Terminé',
      'Provider Accepted': 'Fournisseur accepté',
      'Dispatch created': 'Expédition créée',
      'Driver Assigned': 'Chauffeur assigné',
      'Provider Cancelled': 'Fournisseur annulé',
      'Customer Cancelled': 'Client annulé',
      'Customer or vehicle not at Pick Up': 'Client ou véhicule non à la prise en charge',
      'Searching For Providers': 'Recherche de fournisseurs',
      'Processing Auto Dispatch': 'Traitement de la répartition automatique',
      'Awaiting Manual Dispatch': 'En attente d\'envoi manuel',
    },
    types: {
      all: 'Tout',
      onDemand: 'Sur demande',
      scheduled: 'Programmé',
      approvalRequired: 'approbation exigée',
      outOfNetwork: 'Out Of Network',
      secondary: 'Secondaire',
    }
  },
  grid: {
    columns: {
      dispatchCustomer: 'Expédition / Client',
      dispatchDate: 'Date d\'expédition',
      service: 'Service',
      locations: 'Emplacements',
      providerDriver: 'Fournisseur',
      actions: 'Actions',
      clientNameAndDispatchId: 'Client / ID d\'expédition',
      motoristNameAndPhone: 'Nom du conducteur / Téléphone',
      created: 'Créé',
      eta: 'ETA / Assigné',
      timeStatus: 'Statut temporel',
      serviceType: 'Type de service',
      statusState: 'Statut / État',
      csrAssigned: 'CSR assigné',
      providerAssigned: 'Fournisseur assigné',
      callDetails: 'Détails de l\'appel',
    }
  }
};
